import { ICourseInterface } from '../../interfaces/Website/Courses/CoursesCategory/ICoursesCategory'
import apiService from '../Api'

export class CoursesCategoryService {
  async list(): Promise<ICourseInterface[]> {
    return apiService.get('course/category').then((res) => res.data.areas)
  }

  async create(data: { name: string }) {
    return apiService.post('/course/category', data).then((res) => res.data)
  }

  async update(id: number, data: { name: string }) {
    return apiService.put(`/course/category/${id}`, data).then((res) => res.data)
  }

  async delete(id: number) {
    return apiService.delete(`/course/category/${id}`)
  }
}
